// extracted by mini-css-extract-plugin
module.exports = {"main":"GiveawaySection_main__VmVdM","wrapper":"GiveawaySection_wrapper__kw5ZM","scroll":"GiveawaySection_scroll__5Gi37"};